import $ from 'jquery';

export function scroll_down()
{

	$('.home-hero__darr').on('click', function()
	{
		let offset = $('.header--strapline').offset().top;
		let menu   = $('.footer-nav').innerHeight();
		let page_width = $(window).innerWidth();

		if( page_width < 900 )
		{
			offset = offset - menu
		}

		$('html, body').animate({
			scrollTop: offset,
		}, 800 );
	});
}

export function window_scroll()
{


	$(window).on('scroll', function() {

		if( $('.home-hero').length > 0 )
		{
			console.log('1');
			let scroll_top = $(this).scrollTop();
			let offset = $('.home-hero').offset().top + $('.home-hero').height();
			let body = $('body');

			if(scroll_top >= offset)
			{
				body.addClass('scrolled-passed');
			}
			else
			{
				body.removeClass('scrolled-passed');
			}
		}
	});
}



// WEBPACK FOOTER //
// ./scripts/modules/scroll.js